export default __webpack_public_path__ + "static/1242-46c570576c78d7c5ea00e22c9af04785.gif";